import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e8c237ba&%23default=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@4.3.0_lodash@4.17._ziirscntm6ri7or2susu3mlgei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports